import ServiceError from "./ServiceError"

import ApiClient from "./ApiClient"

export default class CollectionService {
  // map plugins field names to api param names
  paramMapping = {
    selected_formats: "formats",
    tx_headless_selected_categories: "categories", // could be categories or root_categories
    root_categories: "root_categories",
    tx_headless_selected_items: "uids",
    show_noindex_items: "show_noindex_items",
    user_selected_formats: "user_selected_formats", // implement!
    user_selected_root_categories: "user_selected_root_categories", // implement!
    filter_type: "user_filter_type",
    pageUid: "exclude_uids",
  }
  initialParams = null
  userFilterParams = null

  constructor(options) {
    const apiEndpoint =
      options.apiEndpoint || process.env.REMOTE_COLLECTION_API_ENDPOINT
    this.itemsPerPage = options.items_per_page || options.limit
    this.apiClient = new ApiClient("collection", apiEndpoint)

    this.filterableValues = null
    this.subsequentFilterableValues = null
    this.lastRequestMeta = null
    this.lastRequestHeader = null

    this.setInitialParams(options)
  }

  setInitialParams(fields) {
    this.initialParams = this.mapFieldsToApiParams(fields)
  }

  setUserFilterParams(userFilterFields) {
    this.userFilterParams = userFilterFields
  }

  mapFieldsToApiParams(fields) {
    const knownFieldNames = Object.keys(this.paramMapping)
    return Object.keys(fields)
      .filter((fieldName) => {
        return knownFieldNames.indexOf(fieldName) !== -1
      })
      .filter((fieldName) => {
        return fields[fieldName]
      })
      .map((fieldName) => {
        let result = {}
        result[this.paramMapping[fieldName]] = fields[fieldName]
        return result
      })
  }

  buildRequestParams(page) {
    let show_filterable_values_param = "show_filterable_values=true"
    let category_limit_param =
      "limit_collections_filter_categories=" +
      (process.env.LIMIT_COLLECTIONS_FILTER_CATEGORIES === "true"
        ? "true"
        : "false")
    let params = this.initialParams

    if (this.userFilterParams) {
      params = params.concat(this.userFilterParams)
    }

    return (
      "?" +
      params
        .map((obj) => {
          return `${Object.keys(obj)[0]}=${obj[Object.keys(obj)[0]]}`
        })
        .concat(this.pageToLimitOffsetParams(page))
        .concat(show_filterable_values_param)
        .concat(category_limit_param)
        .join("&")
    )
  }

  pageToLimitOffsetParams(page) {
    return `limit=${this.itemsPerPage}&offset=${(page - 1) * this.itemsPerPage}`
  }

  apiResultHandler(data, page) {
    if (!Array.isArray(data.results)) {
      console.error("Unexpected content response", data)
      throw new ServiceError(
        ServiceError.STATUS_INVALID_DATA,
        "Collection service got unexpected data"
      )
    }

    if (
      page === 1 &&
      (this.userFilterParams === null || this.userFilterParams.length === 0)
    ) {
      this.filterableValues = data.filterable_values || null
      this.subsequentFilterableValues = null
    }

    if (this.userFilterParams !== null && this.userFilterParams.length > 0) {
      this.subsequentFilterableValues = data.filterable_values || null
      this.filterableValues = null
    }

    if (data.meta) {
      this.lastRequestMeta = data.meta
    }

    if (data.header) {
      this.lastRequestHeader = data.header
    }

    return data.results
  }

  async getCollectionForSinglePage(page) {
    return this.apiResultHandler(
      await this.apiClient.get(this.buildRequestParams(page)),
      page
    )
  }
}
